import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';

const LoginPage = ({ onLogin, defaultRedirect = '/admin' }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [token, setToken] = useState(''); // 2FA Kodu
    const [show2FA, setShow2FA] = useState(false); // 2FA Ekranı Gösterilsin mi?
    const [setupMode, setSetupMode] = useState(false); // İlk kurulum (QR göster)
    const [qrCode, setQrCode] = useState(''); // QR kod data URL
    const [secret, setSecret] = useState(''); // Manuel giriş için base32
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'PayzoPay - Giriş Yap';
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = { username, password };
            if (show2FA) {
                payload.token = token;
            }

            const res = await api.login(payload);

            // İlk giriş: 2FA kurulumu zorunlu — QR göster
            if (res.data.require2FASetup) {
                setSetupMode(true);
                setShow2FA(true);
                setQrCode(res.data.qrCode);
                setSecret(res.data.secret || '');
                return;
            }

            // 2FA zaten kurulu: sadece kod iste
            if (res.data.require2FA) {
                setSetupMode(false);
                setShow2FA(true);
                return;
            }

            if (res.data.user) {
                onLogin(res.data.user);
                navigate(defaultRedirect); // Giriş başarılıysa ilgili ana sayfaya yönlendir
            }
        } catch (error) {
            alert('Giriş başarısız: ' + (error.response?.data?.error || error.message));
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#1e1e1e', color: '#fff' }}>
            <div className="card" style={{ padding: '40px', width: '100%', maxWidth: '400px', background: '#2d2d2d', borderRadius: '8px', boxShadow: '0 4px 15px rgba(0,0,0,0.5)' }}>
                <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                    <img src="/p_payzo.png" alt="PayzoPay" style={{ width: '90px', height: 'auto' }} />
                </div>
                <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>PayzoPay Giriş</h2>
                <form onSubmit={handleSubmit}>
                    {!show2FA ? (
                        <>
                            <div style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', marginBottom: '10px' }}>Kullanıcı Adı</label>
                                <input
                                    type="text"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    style={{ width: '100%', padding: '12px', borderRadius: '4px', border: '1px solid #444', background: '#333', color: '#fff', boxSizing: 'border-box' }}
                                />
                            </div>
                            <div style={{ marginBottom: '30px' }}>
                                <label style={{ display: 'block', marginBottom: '10px' }}>Şifre</label>
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    style={{ width: '100%', padding: '12px', borderRadius: '4px', border: '1px solid #444', background: '#333', color: '#fff', boxSizing: 'border-box' }}
                                />
                            </div>
                        </>
                    ) : (
                        <div style={{ marginBottom: '30px' }}>
                            {setupMode && (
                                <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                    <p style={{ fontSize: '0.95em', marginBottom: '12px', color: '#ddd' }}>
                                        İlk giriş: Google Authenticator uygulamasıyla aşağıdaki QR kodu okutun,
                                        ardından uygulamadaki 6 haneli kodu girin.
                                    </p>
                                    {qrCode && (
                                        <img src={qrCode} alt="2FA QR Kod" style={{ width: '200px', height: '200px', background: '#fff', padding: '8px', borderRadius: '6px' }} />
                                    )}
                                    {secret && (
                                        <p style={{ fontSize: '0.8em', color: '#aaa', marginTop: '10px', wordBreak: 'break-all' }}>
                                            QR okutamıyorsanız kod: <b style={{ color: '#fff' }}>{secret}</b>
                                        </p>
                                    )}
                                </div>
                            )}
                            <label style={{ display: 'block', marginBottom: '10px' }}>Google Authenticator Kodu</label>
                            <input
                                type="text"
                                value={token}
                                onChange={(e) => setToken(e.target.value)}
                                placeholder="6 haneli kod"
                                style={{ width: '100%', padding: '12px', borderRadius: '4px', border: '1px solid #444', background: '#333', color: '#fff', boxSizing: 'border-box', textAlign: 'center', fontSize: '1.2em', letterSpacing: '5px' }}
                                autoFocus
                            />
                        </div>
                    )}
                    <button type="submit" style={{ width: '100%', padding: '12px', background: '#007bff', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '16px', fontWeight: 'bold' }}>
                        {show2FA ? (setupMode ? 'Kurulumu Tamamla' : 'Doğrula') : 'Giriş Yap'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;